import { type DrillDownType } from "~/utils/drilldownUtils"

export type SaleMetric =
  | "addedQuantityStockOut"
  | "addedQuantityMissingCollection"
  | "addedQuantityDiscount"
  | "addedQuantityPreOrder"
  | "addedQuantityExpectedPreOrder"
  | "aiForecast"

export const DEFAULT_BASELINE_METRICS: SaleMetric[] = [
  "addedQuantityPreOrder",
  "addedQuantityExpectedPreOrder",
  "addedQuantityMissingCollection",
]

const DEFAULT_NO_BASELINE_METRICS: SaleMetric[] = ["aiForecast"]

export const getDefaultSalesMetrics = (hasBaseline: boolean): SaleMetric[] =>
  hasBaseline ? [...DEFAULT_BASELINE_METRICS] : [...DEFAULT_NO_BASELINE_METRICS]

const METRIC_PARENT: Partial<Record<SaleMetric, SaleMetric>> = {
  addedQuantityExpectedPreOrder: "addedQuantityPreOrder",
}

export const isMetricEffective = (enabledSalesMetrics: string[], metric: string): boolean => {
  if (!enabledSalesMetrics.includes(metric)) return false
  const parent = METRIC_PARENT[metric as SaleMetric]
  return parent === undefined || enabledSalesMetrics.includes(parent)
}

export const BASELINE_METRIC_CONFIG: { key: SaleMetric; drilldown: DrillDownType }[] = [
  { key: "addedQuantityPreOrder", drilldown: "PreorderChange" },
  { key: "addedQuantityExpectedPreOrder", drilldown: "ExpectedPreorderChange" },
  { key: "addedQuantityStockOut", drilldown: "Stockouts" },
  { key: "addedQuantityMissingCollection", drilldown: "UnfinishedCollection" },
  { key: "addedQuantityDiscount", drilldown: "MarkdownImpact" },
]
